const formater = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
})

export default function formatPrice(price, qtd = 1) {
  return formater.format(price * qtd)
}
